// extracted by mini-css-extract-plugin
export default {"wrapper":"qB-z","viewport":"rB-z","container":"sB-z","slide":"tB-z"};